<template>
  <v-data-table
    :items="items"
    :headers="getHeaders"
    :items-per-page="items.length + 1"
    hide-default-footer
    :hide-default-header="$vuetify.breakpoint.xsOnly"
    :mobile-breakpoint="0"
    multi-sort
    :sort-by="['display_order', 'nom']"
    :sort-desc="[false, false]"
    dense
    :search="search"
    class="no-before"
  >
    <template v-slot:header.display_order>
      <v-tooltip top v-if="!$vuetify.breakpoint.xsOnly">
        <template v-slot:activator="{ on }">
          <v-icon small v-on="on">fa-list-ol</v-icon>
        </template>
        <span>Ordre d'affichage</span>
      </v-tooltip>
    </template>
    <template v-slot:item.display_order="{ item }">
      <span class="caption" v-if="!$vuetify.breakpoint.xsOnly">{{
        item.display_order
      }}</span>
    </template>
    <template v-slot:item.quantity="{ item }">
      <div style="min-width: 75px">
        <span :class="$vuetify.breakpoint.xsOnly ? 'caption' : ''">{{
          `${item.computedQuantity} ${item.unit}`
        }}</span>
      </div>
    </template>
    <template v-slot:item.values="{ item }">
      <div style="min-width: 75px">
        <span :class="$vuetify.breakpoint.xsOnly ? 'caption' : ''">{{
          getValue(item)
        }}</span>
      </div>
    </template>
    <template v-slot:top v-if="!hideTop && getIsAdmin">
      <v-row align="center">
        <v-col>
          <span class="subtitle-2">Valeur total: {{ getTotalValue }} $</span>
        </v-col>
      </v-row>
    </template>
  </v-data-table>
</template>

<script>
import round10 from "round10";
import { mapGetters } from "vuex";
export default {
  name: "InventoryRecordViewGrid",
  props: {
    items: {
      type: Array,
      required: true
    },
    search: {
      required: false
    },
    hideTop: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["getIsAdmin"]),
    getTotalValue() {
      return round10.round10(
        this.items
          .map(x => Number(x.computedQuantity) * Number(x.price))
          .reduce((a, b) => a + b, 0),
        -2
      );
    },
    getHeaders() {
      let headers = [];
      if (this.getIsAdmin) {
        headers = [
          {
            value: "display_order",
            text: "",
            sort: function(a, b) {
              if (a === b) {
                return 0;
              } else if (a === null) {
                return 1;
              } else if (b === null) {
                return -1;
              } else {
                return a < b ? -1 : 1;
              }
            }
          },
          { value: "nom", text: "Nom" },
          { value: "quantity", text: "Quantité" },
          { value: "values", text: "Valeur" },
          { value: "comments", text: "Commentaire" }
        ];
      } else {
        headers = [
          {
            value: "display_order",
            text: "",
            sort: function(a, b) {
              if (a === b) {
                return 0;
              } else if (a === null) {
                return 1;
              } else if (b === null) {
                return -1;
              } else {
                return a < b ? -1 : 1;
              }
            }
          },
          { value: "nom", text: "Nom" },
          { value: "quantity", text: "Quantité" },
          { value: "comments", text: "Commentaire" }
        ];
      }
      if (this.$vuetify.breakpoint.xsOnly) {
        headers = headers.filter(x => x.value !== "comments");
      }
      return headers;
    }
  },
  methods: {
    getValue(item) {
      const value = round10.round10(
        Number(item.computedQuantity) * Number(item.price),
        -2
      );
      return value === 0 ? null : `${value} $`;
    }
  }
};
</script>

<style lang="scss" scoped></style>
